import React from "react";
import AnimatedText from "../Components/animation/text/AnimatedText";
import Timeline from "../Components/Timeline";


const career = () => {

    return (
        <div id="career" className="w-full flex flex-col items-center justify-center overflow-hidden mt-10">
            <div className="w-full xl:w-[70%] flex flex-row pb-16">
                <div className="w-full">
                    <AnimatedText text="Career" />

                    <p className="text-secondary-400 text-[18px] mt-5 ml-14">
                        Here's a <span className="font-bold bg-clip-text bg-gradient-to-tr from-pink-600 to-purple-700"> timeline of my career</span>, starting from my current position and moving back to my first job, including some side projects

                    </p>
                    <p className="text-secondary-400 text-[18px] mt-1 ml-10">

                        from the companies I've worked with along the way.

                    </p>



                </div>

            </div>

            <Timeline />

        </div>
    );

}

export default career;
